module.exports = __webpack_public_path__ + "media/images/shark/SharkCafeMap-p-500-2aecd7567e3cc2bf083b7103ac0f4a4c.jpg";